import {Component, OnInit} from '@angular/core';
import {DisplayedColumnInf} from '../../../interfaces/common/table/displayed-column-inf';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {OperatorRoleType} from '../../../services/enums/operator-role-type.enum';
import {
  OperatorsSettingsApiService
} from '../../../services/api/settings/administration/operators/operators-settings-api.service';
import {UsedInElementsPipe} from './used-in-elements.pipe';
import {MatDialog} from '@angular/material/dialog';
import _ from 'lodash';
import {SnackBarService} from '../../../services/common/snack-bar/snack-bar.service';
import {
  ConfiguratorCredentialsDialogComponent
} from './configurator-credentials-dialog/configurator-credentials-dialog.component';
import {AcDialogService} from 'ac-infra';
import {ConfirmationDialogComponent} from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {RoleTypeEnum} from '../../../services/enums/role-type.enum';

@Component({
  selector: 'configurator-credentials',
  templateUrl: './configurator-credentials.component.html',
  styleUrls: ['./configurator-credentials.component.scss'],
})
export class ConfiguratorCredentialsComponent implements OnInit {

  private configuratorCredentialsFilter = {
    filter: {
      type: {
        operator: '=',
        value: [OperatorRoleType.DEVICE, OperatorRoleType.ROUTER]
      },
      isDetailed: {
        operator: '=',
        value: true
      }
    }
  };

  displayedColumns: Array<DisplayedColumnInf> = [
    {name: 'userName', display: 'User name', selected: true,  width: 50},
    {name: 'type', display: 'Type', selected: true, width: 100},
    {name: 'names', display: 'Used in elements', selected: true, width: 150, transformer: UsedInElementsPipe},
  ];

  items: [];
  isUnauthorized: boolean;
  selection;

  constructor(private userPrivilege: UserPrivilegeService,
              private operatorsSettingsApiService: OperatorsSettingsApiService,
              private acDialogService: AcDialogService,
              private snackBarService: SnackBarService,
              private dialog: MatDialog) { }

  ngOnInit(): void {
    this.isUnauthorized = !this.userPrivilege.isAuthorized(RoleTypeEnum.SECURITY_ADMIN);
    this.refresh();
  }

  addItem(): void {
    const dialogData = {
      isEditMode: false,
      selectedItem: {userName: '', passwordConfirm: null},
    };

    this.acDialogService.open(ConfiguratorCredentialsDialogComponent, {
      dialogData,
      onSubmit: () => {
        delete dialogData.selectedItem.passwordConfirm;
        this.operatorsSettingsApiService.addOperator(dialogData.selectedItem).subscribe(() => {
          this.snackBarService.display(`"${dialogData.selectedItem.userName}" successfully added`);
          this.refresh();
        });
      },
      title: 'Add Credentials'
    });
  }

  removeItem(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Are you sure you want to delete the configurator credentials: ${this.selection.userName} ?`
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.operatorsSettingsApiService.deleteOperator(this.selection.id).subscribe(() => {
        dialogRef.close();
        this.snackBarService.display(`"${this.selection.userName}" successfully deleted`);
        this.refresh();
      });
    });
  }

  refresh(): void {
    this.operatorsSettingsApiService.getOperators(this.configuratorCredentialsFilter).subscribe(data => {
      this.items = data.sort(this.compareByRole);
    });
  }

  editItem(): void {
    const dialogData = {
      isEditMode: true,
      selectedItem: _.cloneDeep(this.selection),
    };

    this.acDialogService.open(ConfiguratorCredentialsDialogComponent, {
      dialogData,
      onSubmit: () => {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          data: {
            message: `Updating user name or password might cause temporary connectivity
                              problem between ${(dialogData.selectedItem.type === OperatorRoleType.DEVICE) ? 'nodes' : 'routers'} and ARM`
          }
        });

        dialogRef.componentInstance.onApply.subscribe(() => {
          delete dialogData.selectedItem.passwordConfirm;
          this.operatorsSettingsApiService.updateOperator(dialogData.selectedItem).subscribe(() => {
            this.snackBarService.display(`"${dialogData.selectedItem.userName}" successfully updated`);
            this.refresh();
            dialogRef.close();
          });
        });
      },
      title: 'Edit Credentials'
    });
  }

  onSelection(selection: any): void {
    this.selection = selection;
  }

  private compareByRole(operator1, operator2): number {
    if (operator1.role < operator2.role) { return -1; }
    if (operator1.role > operator2.role) { return 1; }

    return 0;
  }
}
